import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-h5 text-center" }
const _hoisted_2 = {
  key: 0,
  class: "text-center text-disabled"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center text-disabled"
}
const _hoisted_4 = {
  key: 2,
  class: "d-flex justify-center mt-5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Выберите пункт выдачи карт.", -1)

import { ref } from 'vue'
import {
  CardStatus,
  IdentityCard,
  getIdentityCardStatus,
  cardStatusName,
  User,
  Id,
  CardIssuePointsService,
  MunicipalEntitiesService,
} from '@prodcard/core'
import { VCardIssuePointSelect } from '../../../../components'

export interface CardWithStatus extends IdentityCard {
  status: CardStatus
}

enum ActionType {
  PRINT = 'print',
  CONFIRM = 'confirm',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IdentityCard',
  props: {
    cardIssuePointsService: {},
    municipalEntitiesService: {},
    card: {},
    currentUser: {},
    municipalEntityId: {},
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["click:print", "click:confirm"],
  setup(__props: any, { emit }) {





const showDialog = ref(false)
const currentActionType = ref<ActionType>(ActionType.PRINT)
const selectedCardIssuePointId = ref<Id | undefined>(undefined)

const badgeColor = (card: IdentityCard) => {
  const status = getIdentityCardStatus(card)
  switch (status) {
    case CardStatus.ACTIVE:
      return 'success'
    case CardStatus.COMPLETED:
      return 'error'
    case CardStatus.NEW:
      return 'info'
  }
}

const updateCard = (card: CardWithStatus, cardIssuePointId?: Id) => {
  if (showDialog.value) showDialog.value = false

  if (!card.cardIssuePointId && !cardIssuePointId) {
    showDialog.value = true
    return
  }

  if (!card.cardIssuePointId && cardIssuePointId) {
    card.cardIssuePointId = cardIssuePointId
  }

  switch (currentActionType.value) {
    case ActionType.PRINT:
      emit('click:print', card)
      return
    case ActionType.CONFIRM:
      emit('click:confirm', card)
      return
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_v_card, {
      width: "500",
      class: "pt-3 pb-5 px-5 mb-5",
      elevation: "3",
      variant: "flat",
      key: _ctx.card.id,
      loading: _ctx.loading,
      disabled: _ctx.disabled
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_badge, {
          color: badgeColor(_ctx.card),
          inline: "",
          content: _unref(cardStatusName)(_ctx.card.status)
        }, null, 8, ["color", "content"]),
        _createElementVNode("h5", _hoisted_1, [
          _createTextVNode(" Карта на "),
          _createElementVNode("strong", null, _toDisplayString(new Date(_ctx.card.year, _ctx.card.month, 1).toLocaleDateString('default', { month: 'long', year: 'numeric' })), 1)
        ]),
        (_ctx.card.confirmedAt)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Выдана " + _toDisplayString(_ctx.card.confirmedAt.toLocaleDateString()), 1))
          : (_ctx.card.status === _unref(CardStatus).COMPLETED)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Не выдавалась"))
            : _createCommentVNode("", true),
        (_ctx.card.status !== _unref(CardStatus).COMPLETED)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_btn, {
                onClick: _cache[0] || (_cache[0] = 
          () => {
            currentActionType.value = ActionType.PRINT
            updateCard(_ctx.card, _ctx.currentUser.cardIssuePointId)
          }
        )
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Сформировать")
                ]),
                _: 1
              }),
              (!_ctx.card.confirmedAt)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: "success",
                    class: "ml-3",
                    onClick: _cache[1] || (_cache[1] = 
          () => {
            currentActionType.value = ActionType.CONFIRM
            updateCard(_ctx.card, _ctx.currentUser.cardIssuePointId)
          }
        )
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Подтвердить выдачу ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["loading", "disabled"])),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showDialog).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          variant: "flat",
          class: "pb-5 pl-5 pr-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_actions, { class: "justify-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showDialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Закрыть")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_5,
            _createVNode(_unref(VCardIssuePointSelect), {
              class: "mt-5",
              modelValue: selectedCardIssuePointId.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedCardIssuePointId).value = $event)),
              "card-issue-points-service": _ctx.cardIssuePointsService,
              "municipal-entities-service": _ctx.municipalEntitiesService,
              "additional-filter-data": { municipalEntityId: _ctx.municipalEntityId },
              density: "comfortable"
            }, null, 8, ["modelValue", "card-issue-points-service", "municipal-entities-service", "additional-filter-data"]),
            _createVNode(_component_v_card_actions, { class: "justify-end mt-8 pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  disabled: !selectedCardIssuePointId.value,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (updateCard(_ctx.card, selectedCardIssuePointId.value)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Применить ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})